module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/business/business-profile/business-profile/business-profile/business-profile.component.css
// module id = ./src/app/components/business/business-profile/business-profile/business-profile/business-profile.component.css
// module chunks = main